import React from 'react';

/**
 * Tab navigation component for switching between different views
 * 
 * @param {Object} props - Component props
 * @param {string} props.currentTab - Currently active tab
 * @param {Function} props.setCurrentTab - Function to change the active tab
 * @param {Array} props.tabs - Array of tab objects with id and label properties
 */
const TabNavigation = ({ 
  currentTab, 
  setCurrentTab, 
  tabs = [
    { id: 'summary', label: 'Summary' },
    { id: 'table', label: 'Data Table' },
    { id: 'strengths', label: 'Model Strengths' }
  ] 
}) => {
  return (
    <div className="flex mb-4 border-b overflow-x-auto">
      {tabs.map((tab) => (
        <button 
          key={tab.id}
          className={`px-4 py-3 ${currentTab === tab.id ? 'border-b-2 border-blue-600 font-medium' : 'text-gray-500'}`}
          onClick={() => setCurrentTab(tab.id)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};


export default TabNavigation;
